import {Routes} from '@angular/router';
import {AdminLayout} from './pages/admin-layout/admin-layout';
import {Dashboard} from './pages/dashboard/dashboard';
import {ManageUserProfile} from './pages/manage-user-profile/manage-user-profile';
import {UserProfileOnboarding} from './pages/user-profile/onboarding/user-profile-onboarding';
import {UserBusiness} from './pages/user-business/user-business';
import {AddBusinessPage} from './pages/user-business/add/add-business-page';
import {UserCertificate} from './pages/user-certificate/user-certificate';
import {ViewProfileComponent} from './pages/view-profile/view-profile.component';
import {viewProfileResolver} from './pages/view-profile/view-profile.resolver';
import {autoLoginPartialRoutesGuard} from 'angular-auth-oidc-client';
import {CallbackComponent} from './callback/callback.component';
import {authGuard} from './shared/guards/auth.guard';
import {profileCompletionGuard} from './shared/guards/profile-completion.guard';
import {portalProfileOnboardingGuard} from './shared/guards/portal-profile-onboarding.guard';
import {RoleAssign} from './pages/role-assign/role-assign';
import {RoleInvitationListComponent} from './pages/role-invitations/role-invitation-list.component';
import {RoleInvitationDetailComponent} from './pages/role-invitations/role-invitation-detail.component';
import {Chat} from './pages/chat/chat';
import {Survey} from './pages/survey/survey';
import {QrTraceConfirm} from './pages/qr-trace-confirm/qr-trace-confirm';
import {TradeListComponent} from './pages/trade/list/trade-list.component';
import {TradeHarvestFormComponent} from './pages/trade/harvest-form/trade-harvest-form.component';
import {TradeReceiveComponent} from './pages/trade/receive/trade-receive.component';
import {TradeTransformComponent} from './pages/trade/transform/trade-transform.component';
import {TradeSellComponent} from './pages/trade/sell/trade-sell.component';
import {TradeOfferComponent} from './pages/trade/offer/trade-offer.component';
import {TradeDetailComponent} from './pages/trade/detail/trade-detail.component';
import {TradeObservationsComponent} from './pages/trade/observations/trade-observations.component';
import {MobileQrScan} from './pages/mobile-qr-scan/mobile-qr-scan';
import {ThaidCallbackComponent} from './pages/thaid-callback/thaid-callback.component';
import {dashboardRoleRedirectGuard} from './shared/guards/dashboard-role-redirect.guard';
import {menuRoleGuard} from './shared/guards/menu-role.guard';
import {ForbiddenComponent} from './pages/error/forbidden/forbidden.component';
import {MENU_ROLE_SETS} from './app.constants';

export const routes: Routes = [
  {
    path: 'logout',
    loadComponent: () => import('./shared/auth/signed-out.component').then(m => m.SignedOutComponent),
  },
  {
    path: '',
    redirectTo: 'admin/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'callback',
    component: CallbackComponent
  },
  {
    path: 'thaid-callback',
    component: ThaidCallbackComponent
  },
  {
    path: 'forbidden',
    component: ForbiddenComponent,
    data: {title: 'ไม่มีสิทธิ์เข้าถึง', breadcrumb: 'ไม่มีสิทธิ์เข้าถึง'},
  },
  {
    path: '',
    component: AdminLayout,
    canActivate: [autoLoginPartialRoutesGuard, authGuard],
    canActivateChild: [profileCompletionGuard],
    data: {
      title: 'หน้าหลัก',
      breadcrumb: 'หน้าหลัก',
    },
    children: [
      {
        path: '',
        redirectTo: 'admin/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'admin/dashboard',
        component: Dashboard,
        canActivate: [dashboardRoleRedirectGuard, menuRoleGuard],
        data: {
          roles: MENU_ROLE_SETS.dashboard,
          title: 'แดชบอร์ด',
          breadcrumb: 'แดชบอร์ด',
        },
      },
      {
        path: 'dashboard',
        redirectTo: 'admin/dashboard',
      },
      {
        path: 'admin/business-types',
        loadComponent: () => import('./pages/business-type-settings/business-type-settings.component')
          .then(m => m.BusinessTypeSettingsComponent),
        canActivate: [menuRoleGuard],
        data: {
          roles: MENU_ROLE_SETS.businessTypeSettings,
          title: 'ตั้งค่าประเภทธุรกิจ',
          breadcrumb: 'ตั้งค่าประเภทธุรกิจ',
        },
      },
      {
        path: 'profile',
        component: ManageUserProfile,
        data: {
          title: 'โปรไฟล์',
          breadcrumb: 'โปรไฟล์'
        },
        children: [
          {
            path: 'onboarding',
            component: UserProfileOnboarding,
            canActivate: [portalProfileOnboardingGuard],
            data: {title: 'ตั้งค่าโปรไฟล์', breadcrumb: 'ตั้งค่าโปรไฟล์'}
          },
          {
            path: 'business',
            component: UserBusiness,
            data: {title: 'ข้อมูลธุรกิจ', breadcrumb: 'ข้อมูลธุรกิจ'}
          },
          {
            path: 'business/add',
            component: AddBusinessPage,
            data: {title: 'เพิ่มข้อมูลธุรกิจ', breadcrumb: 'เพิ่มข้อมูลธุรกิจ'}
          },
          {
            path: 'business/edit',
            component: AddBusinessPage,
            data: {title: 'แก้ไขข้อมูลธุรกิจ', breadcrumb: 'แก้ไขข้อมูลธุรกิจ'}
          },
          {
            path: 'certificate',
            component: UserCertificate,
            data: {title: 'ใบรับรอง', breadcrumb: 'ใบรับรอง'}
          },
          {
            path: 'role-assign',
            component: RoleAssign,
            data: {
              title: 'มอบสิทธิ์ใช้งาน',
              breadcrumb: 'มอบสิทธิ์ใช้งาน'
            }
          },
          {
            path: 'role-invitations',
            component: RoleInvitationListComponent,
            data: {
              title: 'รายการตอบรับคำเชิญ',
              breadcrumb: 'รายการตอบรับคำเชิญ'
            }
          },
          {
            path: 'role-invitations/:id',
            component: RoleInvitationDetailComponent,
            data: {
              title: 'ได้รับมอบหมายให้ดำเนินการแทน',
              breadcrumb: 'ได้รับมอบหมายให้ดำเนินการแทน'
            }
          }
        ]
      },
      {
        path: 'certificate',
        component: UserCertificate,
        data: {
          title: 'ใบรับรอง',
          breadcrumb: 'ใบรับรอง'
        }
      },
      {
        path: 'view-profile',
        component: ViewProfileComponent,
        resolve: {
          profile: viewProfileResolver
        },
        data: {
          title: 'โปรไฟล์',
          breadcrumb: 'โปรไฟล์'
        }
      },
      {
        path: 'chat',
        component: Chat,
        canActivate: [menuRoleGuard],
        data: {
          roles: MENU_ROLE_SETS.chat,
          title: 'แชท',
          breadcrumb: 'แชท'
        }
      },
      {
        path: 'survey',
        component: Survey,
        canActivate: [menuRoleGuard],
        data: {
          roles: MENU_ROLE_SETS.survey,
          title: 'แบบสอบถาม',
          breadcrumb: 'แบบสอบถาม'
        }
      },
      {
        // Older scanner links (and any QR printed with the old path) still land on the receive page.
        path: 'trade-receive',
        redirectTo: 'trade/receive'
      },
      {
        path: 'scan',
        component: MobileQrScan,
        data: {
          title: 'สแกน QR',
          breadcrumb: 'สแกน QR',
          variant: 'mobile',
          fullScreen: true
        }
      },
      {
        path: 'trade',
        canActivate: [menuRoleGuard],
        data: {roles: MENU_ROLE_SETS.purchaseSale},
        children: [
          {
            path: '',
            component: TradeListComponent,
            data: {
              title: 'บันทึกซื้อ-ขาย',
              breadcrumb: 'บันทึกซื้อ-ขาย',
              variant: 'mobile'
            }
          },
          {
            path: 'new',
            component: TradeHarvestFormComponent,
            data: {
              title: 'บันทึกการขาย',
              breadcrumb: 'บันทึกการขาย',
              variant: 'mobile'
            }
          },
          {
            path: 'receive',
            component: TradeReceiveComponent,
            data: {
              title: 'รับซื้อ / รับสินค้า',
              breadcrumb: 'รับซื้อ / รับสินค้า',
              variant: 'mobile'
            }
          },
          {
            path: 'transform',
            component: TradeTransformComponent,
            data: {
              title: 'แปรรูปสินค้า',
              breadcrumb: 'แปรรูปสินค้า',
              variant: 'mobile'
            }
          },
          {
            path: 'sell',
            component: TradeSellComponent,
            data: {
              title: 'สร้างใบขาย',
              breadcrumb: 'สร้างใบขาย',
              variant: 'mobile'
            }
          },
          {
            // Before `:id`. Officers only (see MENU_ROLE_SETS.observations).
            path: 'observations',
            component: TradeObservationsComponent,
            canActivate: [menuRoleGuard],
            data: {
              roles: MENU_ROLE_SETS.observations,
              title: 'รายงานข้อสังเกตเส้นทางสินค้า',
              breadcrumb: 'รายงานข้อสังเกต'
            }
          },
          {
            // Before `:id`, which would otherwise swallow `offers/…`.
            path: 'offers/:id',
            component: TradeOfferComponent,
            data: {
              title: 'ใบขาย',
              breadcrumb: 'ใบขาย',
              variant: 'mobile'
            }
          },
          {
            path: ':id',
            component: TradeDetailComponent,
            pathMatch: 'full',
            data: {
              title: 'รายละเอียดรายการ',
              breadcrumb: 'รายละเอียดรายการ',
              variant: 'mobile'
            }
          },
          {
            path: ':id/edit',
            component: TradeHarvestFormComponent,
            data: {
              title: 'แก้ไขรายการ',
              breadcrumb: 'แก้ไขรายการ',
              variant: 'mobile'
            }
          }
        ]
      },
      {
        path: 'qr-trace-confirm',
        component: QrTraceConfirm,
        canActivate: [menuRoleGuard],
        data: {
          roles: MENU_ROLE_SETS.qrTrace,
          title: 'ยืนยันการจำหน่าย (QR Trace)',
          breadcrumb: 'ยืนยันการจำหน่าย (QR Trace)',
        }
      },
      {
        path: 'business-info',
        component: UserBusiness,
        data: {
          title: 'จัดการข้อมูลธุรกิจ',
          breadcrumb: 'จัดการข้อมูลธุรกิจ'
        }
      },
      {
        path: 'business-info/add',
        component: AddBusinessPage,
        data: {title: 'เพิ่มข้อมูลธุรกิจ', breadcrumb: 'เพิ่มข้อมูลธุรกิจ'}
      },
      {
        path: 'business-info/edit',
        component: AddBusinessPage,
        data: {title: 'แก้ไขข้อมูลธุรกิจ', breadcrumb: 'แก้ไขข้อมูลธุรกิจ'}
      }
    ]
  },
  {
    path: '**',
    loadComponent: () => import('./pages/error/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent)
  }
];
